import { FC } from "react";
import { IonBackdrop } from "@ionic/react";
import { IonBackdropProps } from "../../common/components.types";

export const AllieBackdrop: FC<IonBackdropProps> = ({ ...props }) => {
  return <IonBackdrop {...props} />;
};
